import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SunIcon: React.FC<IconProps> = props => {
  return (
    <BaseIcon viewboxSize="xl" {...props}>
      <path d="M16 23.058a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-6.364-2.05a1 1 0 1 1 1.414 1.414l-2.121 2.121a1 1 0 0 1-1.414-1.414l2.12-2.121Zm11.314-.001a1 1 0 0 1 1.414 0l2.121 2.12a1 1 0 0 1-1.414 1.415l-2.12-2.121a1 1 0 0 1 0-1.414ZM16 11a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-8 2.058a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3Zm19 0a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2h3ZM7.515 7.572a1 1 0 0 1 1.414 0l2.12 2.121a1 1 0 1 1-1.413 1.414l-2.121-2.12a1 1 0 0 1 0-1.415Zm15.556 0a1 1 0 0 1 1.414 1.414l-2.12 2.121a1 1 0 0 1-1.415-1.414l2.121-2.12ZM16 4.058a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" />
    </BaseIcon>
  );
};
